/**
 * @ Author: DY
 * @ Date: 2023-11-02 12:00:18
 * @ LastEditTime: 2023-11-02 12:00:35
 * @ Description: 
 * @ FilePath: \ShiMo_Mobile\src\assets\mixin\mixin_showDecimals.js
 */
export const mixin_showDecimals = {
    data() {
        return {};
    },
    filters: {
        displayDecimalControl: val => {
            val = Number(val);
            let nub = '0.00';
            if (val) {
                nub = val.toFixed(2);
            }
            return nub;
        },
    },
    created() {},
    methods: {},
};